import React, { useState, useEffect } from "react";
import SubHeaderMenu from "../../Sidebar/SubHeaderMenu";
import { useLocation, useNavigate } from "react-router-dom";
import { Table } from "../../Common/Table/Table";
import industryicon from "../../../assets/images/dashboardImg/Industryicon.svg";
import DashbordCard from "../../Common/Cards/DashbordCard";
import { MdOutlineFilterAlt } from "react-icons/md";
import Button from "../../Common/Button";
import useNetworkServices from "../../../Networking/baseAPIManager";
import Dropdown from "../../Common/Dropdown";
import Loader from "../../Common/Loader";
import { debounce } from "lodash";
import { Toastify } from "../../Common/Toastify";

export const KycVerification = () => {
  const location = useLocation();
  const [cardCount, setCardCount] = useState([]);
  const [kycListData, setKycListData] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [filterStatus, setFilterStatus] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("info");
  const [message, setMessage] = useState("");
  const [show, setShow] = useState(false);
  const { merchantKycList } = useNetworkServices();

  const navigate = useNavigate();
  const columns = [
    { header: "Merchant ID", accessor: "id" },
    {
      header: "Merchant Name",
      accessor: "firstName",
      customTxt: (data) => {
        let fullName = `${data.firstName} ${
          data.lastName == undefined ? "" : data.lastName
        }`;
        return <span>{fullName}</span>;
      },
    },
    {
      header: "Shop Name",
      accessor: "",
      customTxt: (data) => {
        let shopName = data?.businessDetils?.shopName
          ? data?.businessDetils?.shopName
          : "N/A";
        return <span>{shopName}</span>;
      },
    },
    {
      header: "Industry",
      accessor: "",
      customTxt: (data) => {
        let industry = data?.businessDetils?.category[0]
          ? data?.businessDetils?.category[0].title
          : "N/A";

        return <span>{industry}</span>;
      },
    },
    {
      header: "Loction",
      accessor: "",
      customTxt: (data) => {
        let Address = `${
          data?.businessDetils?.businessCity
            ? data?.businessDetils?.businessCity
            : ""
        } ${
          data?.businessDetils?.businessState
            ? data?.businessDetils?.businessState
            : ""
        }`;

        let location =
          data?.businessDetils?.businessCity ||
          data?.businessDetils?.businessState
            ? Address
            : "N/A";
        return <span>{location}</span>;
      },
    },
    {
      header: "Status",
      accessor: "kyc",
      customTxt: (data) => {
        console.log(data, "data=====");
        let color =
          data?.kyc === "Pending"
            ? "#F07403"
            : data?.kyc === "Approved"
            ? "#1F9254"
            : "#CD6200";

        let bgColor =
          data?.kyc === "Pending"
            ? "#FFF4E5"
            : data?.kyc === "Approved"
            ? "#E5F7ED"
            : "#FDF0E3";

        return (
          <span
            style={{
              color,
              backgroundColor: bgColor,
              borderRadius: "0.8rem",
              padding: "0.5rem",
              display: "inline-block",
              textAlign: "center",
              width: "100px",
              overflow: "hidden",
              whiteSpace: "nowrap",
            }}
          >
            {data.kyc}
          </span>
        );
      },
    },

    {
      header: "Action",
      accessor: "",
      customBtn: (data) => {
        return (
          <Button
            type="button"
            label="View Detail"
            className="text-[#025D89]"
            onClick={() =>
              navigate("/kyc_verification/view_detail", { state: data })
            }
          />
        );
      },
    },
  ];
  const card = [
    {
      icon: industryicon,
      iconContainer: "#CEE4EF ",
      title: "Kyc Request",
      content: cardCount.totalKycCount || 0,
    },
    {
      icon: industryicon,
      iconContainer: "#CEE4EF ",
      title: "Kyc Pending",
      content: cardCount.Pending || 0,
    },
    {
      icon: industryicon,
      iconContainer: "#CEE4EF ",
      title: "Kyc Approved  ",
      content: cardCount.Approved || 0,
    },
    {
      icon: industryicon,
      iconContainer: "#CEE4EF ",
      title: "Kyc Reject",
      content: cardCount.Reject || 0,
    },
  ];

  const option = [
    { value: "All", name: "All kyc " },
    { value: "Approved", name: "Kyc Approved" },
    { value: "Pending", name: "Kyc Pending" },
    { value: "Reject", name: "Kyc Reject" },
  ];
  useEffect(() => {
    const kycList = async () => {
      setLoading(true);
      try {
        const response = await merchantKycList();
        // console.log(response?.data?.data,"response")
        setCardCount(response?.data?.data?.kycStatusCounts);
        setKycListData(response?.data?.data?.merchantList);
      } catch (error) {
        console.error(error, "error");
      } finally {
        setLoading(false);
      }
    };
    kycList();
  }, []);

  const handleSearch = debounce((query) => {
    setSearchQuery(query.toLowerCase());
  }, 300);

  useEffect(() => {
    const filtered = kycListData.filter((item) => {
      const matchesStatus =
        filterStatus === "All" || !filterStatus
          ? kycListData
          : item.kyc === filterStatus;
      const searchValues = [
        item?.businessDetils?.shopName,
        item?.id,
        `${item?.firstName} ${item?.lastName}`,
        `${item?.businessDetils?.businessCity} ${item?.businessDetils?.businessState}`,
        item?.businessDetils?.category[0]?.title,
      ]
        .join(" ")
        .toLowerCase();
      return matchesStatus && searchValues.includes(searchQuery);
    });
    setFilterData(filtered);
  }, [filterStatus, kycListData, searchQuery]);

  return (
    <div id="main" className="p-4">
      <Toastify type={type} message={message} show={show} setShow={setShow} />
      <h1 className="font-bold text-2xl text-slate-900 pb-5">
        <span>Merchant Management</span> /{" "}
        <span className="text-red-500">
          <SubHeaderMenu location={location} />
        </span>
      </h1>
      <div className="py-2">
        <DashbordCard card={card} iconClass="rounded-full" />
      </div>
      <div className="w-full flex justify-between items-center pe-5 py-5 ">
        <div className="flex items-center w-1/2">
          <input
            type="text"
            placeholder="Search by merchent detail"
            onChange={(e) => handleSearch(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none "
          />
        </div>
        <div className="w-36 h-auto flex justify-center items-center border-[1px] bg-[#025D89] rounded-lg py-1 gap-1">
          <MdOutlineFilterAlt className="text-white " />
          <Dropdown
            option={option}
            value={filterStatus}
            onChange={(e) => setFilterStatus(e.target.value)}
            SelectClass="bg-[#025D89] text-white outline-none "
          />
        </div>
      </div>
      <div>
        <Table columns={columns} data={filterData} tableClass="h-[430px] xl:h-[520px]" />
      </div>
      {loading && <Loader />}
    </div>
  );
};
